import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/tenant/applications/application/root'

export const apisRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/apis',
    component: lazyRouteComponent(() => import('./APIs'), 'APIs'),
    loader: ({ parentMatchPromise }) => parentMatchPromise,
})
